import { getCookie, updateCookie, clearCookie, addCookie, getCookieByName, removeCookieByName } from './cookie';
import { getToken } from './getTonken';
import { getTime, getMMSS } from './getTIme';
import ToastUtils from './ToastUtils';
import moment from 'moment';
import CryptoJS from 'crypto-js';

const utils = {
    getCookie,
    updateCookie,
    clearCookie,
    getToken,
    getTime,
    getMMSS,
    addCookie,
    getCookieByName,
    removeCookieByName
};
export default utils;

export const dateFormat = (date, format = 'YYYY-MM-DD HH:mm:ss', seat = '-') => {
    return date ? moment(date).format(format) : seat;
};
export const filterHtml = (htmlString) => {
    return htmlString?.replace(/<[^>]*>/g, ''); // 使用正则表达式去除HTML标记
};
export const decodeHtml = (htmlString) => {
    if (!htmlString) return '';
    return htmlString.replace(/&nbsp;/g, ' ').replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};
export const urlSearchParamsToObject = (url) => {
    let location = new URL(url),
        searchParams = new URLSearchParams(location.search),
        paramsObject = {};
    for (let [key, value] of searchParams) {
        paramsObject[key] = value;
    }
    return paramsObject;
};
export const objectToUrlSearchParams = (obj) => {
    let searchParams = new URLSearchParams();
    for (let key in obj) {
        searchParams.append(key, obj[key]);
    }
    return searchParams.toString();
};
export const copyText = (text) => {
    const textToCopy = text,
        // 创建一个虚拟input元素
        input = document.createElement('input');
    input.value = textToCopy;
    document.body.appendChild(input);
    // 选择输入框的内容
    input.select();
    // 执行复制操作
    document.execCommand('copy');
    // 移除虚拟input元素
    document.body.removeChild(input);
    // 可以显示一条消息或者执行其他操作
    ToastUtils.showSuccessToast('复制成功');
};

export const decodeHtmlAll = (htmlString) => {
  if (!htmlString) return '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.documentElement.textContent;
};


/**
 * AES加密函数
 * 使用AES算法对原始文本进行加密，采用ECB模式和Pkcs7填充
 * PKCS5Padding 在 crypto-js 中对应 Pkcs7
 * @param {string} originalText - 需要加密的原始文本
 * @param {string} key - 加密密钥，需为Base64编码格式
 * @returns {string} 加密后的密文字符串
 */
export const encryptAES = (originalText, key) => {
    if (!originalText || !key) return '';
    const encrypted = CryptoJS.AES.encrypt(originalText, CryptoJS.enc.Base64.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
};

/**
 * AES解密函数
 * 使用AES算法对密文进行解密，采用ECB模式和Pkcs7填充
 * PKCS5Padding 在 crypto-js 中对应 Pkcs7
 * @param {string} encriptedText - 需要解密的密文
 * @param {string} key - 解密密钥，需为Base64编码格式
 * @returns {string} 解密后的原始文本
 */
export const decryptAES = (encriptedText, key) => {
    if (!encriptedText || !key) return '';
    const decrypted = CryptoJS.AES.decrypt(encriptedText, CryptoJS.enc.Base64.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};

